<template lang="pug">
	.sud-card-footer
		slot
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'app-card-footer'
}
</script>

<style scoped>
.sud-card-footer {
  background: #F0F0F0;
  padding: 0px 16px 2px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;

  color: #959595;
}
</style>
